export default <T>(x: T) => {
    return x;
}